// src/components/Payment/addbanner.js
import React from 'react';

const Addbanner = () => {
  return (
    <div>
      <h2>addbanner</h2>
      <p>This is the addbanner component.</p>
    </div>
  );
};

export default Addbanner;
